// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3kvfs","addAppConfigBtn":"styles_addAppConfigBtn__3TkMZ"};